import { Component, Input, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject, takeUntil } from "rxjs";
import { USER_TYPE } from "src/app/core/helpers/global/global.constant";
import { TYPES_USER_PERMISSIONS } from "src/app/core/helpers/global/user-management.constant";
import { FORMAT_FOR_CURRENCY_DIGITS } from "src/app/core/helpers/ui/ui.constant";
import { User } from "src/app/core/interfaces/api/user.interface";
import { BootstrapModalService } from "src/app/core/services/ui/bootstrap-modal.service";
import { GlobalService } from "src/app/core/services/ui/global.service";

@Component({
  selector: "app-balance-cards-form",
  templateUrl: "./balance-cards-form.component.html",
})
export class BalanceCardsFormComponent implements OnInit, OnDestroy {
  @Input() balance: number = 0.0;
  @Input() credit: number = 0.0;
  @Input() currencyCode: string = "";

  public balanceProfile: number = 0.0;
  public creditProfile: number = 0.0;
  public totalBalanceProfile: number = 0.0;
  public currencyCodeProfile: string = "";
  public totalBalanceAgent: number = 0.0;
  public selectedOption: string | null = null;
  public cardTitle: string = "";
  public isCreditAgent: boolean = false;
  private unsubscribe$ = new Subject<void>();

  public FORMAT_FOR_CURRENCY_DIGITS = FORMAT_FOR_CURRENCY_DIGITS;
  public USER_TYPE = USER_TYPE;

  constructor(
    private _profileService: GlobalService,
    private modalService: BootstrapModalService<string>,
    private _translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.loadProfile();
    this.getModalData();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnChanges(changes: any): void {
    if (changes.balance || changes.credit || changes.currencyCode) {
      this.loadProfile();
    }
  }

  private loadProfile() {
    this._profileService.profile
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((profile) => {
        if (profile && profile.currencies.length > 0) {
          const currency = profile.currencies.find(
            (profileCurrency) => profileCurrency.currencyId.code === this.currencyCode
          );
          if (currency) {
            if (profile.userType === TYPES_USER_PERMISSIONS.AGENT) {
              const commissionHold = currency.commissionHold ?? 0;
              this.balanceProfile = currency.balance + currency.credit - commissionHold;
              this.creditProfile = commissionHold;
            } else {
              this.balanceProfile = currency.balance || 0.0;
              this.creditProfile = currency.credit || 0.0;
            }
            this.currencyCodeProfile = currency.currencyId.code;
            this.calculateTotals();
          } else {
            this.resetProfileData();
          }
        }
      });
  }

  private calculateTotals() {
    this.totalBalanceProfile = this.balanceProfile + this.creditProfile;
    this.totalBalanceAgent = this.balance + this.credit;
  }

  private resetProfileData() {
    this.balanceProfile = 0.0;
    this.creditProfile = 0.0;
    this.currencyCodeProfile = "";
    this.totalBalanceProfile = 0.0;
    this.totalBalanceAgent = 0.0;
  }

  getModalData() {
    this.modalService
      .getDataIssued()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: string | null) => {
        if (data === USER_TYPE.CREDIT_AGENT) {
          this.selectedOption = USER_TYPE.AGENT;
          this.isCreditAgent = true;
        } else {
          this.selectedOption = data;
          this.isCreditAgent = false;
        }
        this.setCardTitle();
      });
  }
  setCardTitle(): void {
    switch (this.selectedOption) {
      case USER_TYPE.AGENT:
        this.cardTitle = this._translateService
          .instant("transfer.agent")
          .toLowerCase();
        break;
      case USER_TYPE.COLABORATOR:
        this.cardTitle = this._translateService
          .instant("transfer.colaborator")
          .toLowerCase();
        break;
      case USER_TYPE.PLAYER:
        this.cardTitle = this._translateService
          .instant("transfer.player")
          .toLowerCase();
        break;
      default:
        this.cardTitle = this._translateService
          .instant("transfer.titleUnknow")
          .toLowerCase();
    }
  }

  getIconClass(): string {
    switch (this.selectedOption) {
      case USER_TYPE.PLAYER:
        return "fa fa-gamepad";
      case USER_TYPE.AGENT:
        return "fa fa-user-secret";
      case USER_TYPE.COLABORATOR:
        return "fa fa-users";
      default:
        return "fa fa-question-circle";
    }
  }
}
